import axios from "../axios/axios";
import { setSubscriptions } from "../store/actions/subscriptionAction";
import { errorDispatcher } from "../helpers";
import { appSetSendingRequest, setPaymentData } from "../store/actions/appAction";

export const apiGetSubscriptions =
  (token, offlineSubscription = false, cb, businessId) =>
    (dispatch, getState) => {
      let url = "subscriptions/list";
      if (offlineSubscription) {
        url += "?offline=true";
      }
      if (businessId) {
        url += offlineSubscription ? "&businessId=" + businessId : "?businessId=" + businessId
      }
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const subscriptions = response.data.subscriptions
          // const subscriptions = [
          //   ...response.data.subscriptions,
          //   {
          //     id: 4,
          //     title: "بی نهایت",
          //     description: "به صورت نامحدود و بدون تاریخ انقضا از تمامی امکانات چرتکه استفاده کنید",
          //     icon: "https://www.chortke.app/wp-content/uploads/2023/05/Infinity.png",
          //     accountingLimit: 0,
          //     userLimit: 0,
          //     productLimit: 0,
          //     is_currencies: true,
          //     version: 2,
          //     createdAt: "2022-03-06T12:21:11.000Z",
          //     updatedAt: "2022-03-06T12:21:11.000Z",
          //     deletedAt: null,
          //     Subscription_Features: [],
          //     Subscription_Prices: [
          //       {
          //         id: 10,
          //         discount: 0,
          //         price: 11700000,
          //         duration: 0,
          //         renewPrice: 1170000,
          //         version: 2,
          //         createdAt: "2022-03-06T12:21:41.000Z",
          //         updatedAt: "2022-03-06T12:21:41.000Z",
          //         deletedAt: null,
          //         SubscriptionId: 4,
          //       },
          //     ],
          //   },
          // ];
          dispatch(setSubscriptions(subscriptions));
          if (cb) cb(subscriptions, response.data.diff ? response.data.diff : 0 + 20);
        })
        .catch((error) => {
          errorDispatcher(error, dispatch, false);
        });
    };

export const apiSetSubscriptions = (params, token) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post("subscriptions", { params }, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      dispatch(appSetSendingRequest(false));
      dispatch(setPaymentData(params));
      window.location.href = response.data.payment.url;
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSubscriptionPayback = (authority, businessId, token) => (dispatch, getState) => {
  const form = {
    authority,
    businessId,
  };
  axios
    .post("subscriptions/verify", form, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setPaymentData({ ...form, message: response.data.message }));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetSubscriptionsList = (businessId, token, callback) => (dispatch, getState) => {
  axios
    .get(`subscriptions?businessId=${businessId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (callback) {
        callback(response.data.subscriptions);
      }
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
